(function () {
  const PUMPER_RADIO_SELECTOR = '.pumper_pair';
  const SOLE_RELIEF_HANDLE = 'sole-relief%E2%84%A2-therapeutic-foot-roller';

  function parseDisplayedMoney(value) {
    if (!value) return null;

    const cleaned = value.replace(/[^0-9,.-]/g, '');
    const lastComma = cleaned.lastIndexOf(',');
    const lastDot = cleaned.lastIndexOf('.');
    let normalized = cleaned;

    if (lastComma > lastDot) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = cleaned.replace(/,/g, '');
    }

    const amount = Number.parseFloat(normalized);
    return Number.isFinite(amount) ? amount : null;
  }

  function formatMoney(amount) {
    const currency = window.Shopify?.currency?.active || 'GBP';
    const locale = document.documentElement.lang || 'en-GB';

    try {
      return `${new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(amount)} ${currency}`;
    } catch (error) {
      return `£${amount.toFixed(2)} GBP`;
    }
  }

  function updateBundleButtonPrice() {
    document.querySelectorAll(PUMPER_RADIO_SELECTOR).forEach(function (radio) {
      const tier = radio.closest('.pumper_template_9_block_wrapper') || radio.parentElement;
      if (!tier) return;

      const tierPriceElement = tier.querySelector('[id^="pumper_totalAmount_"]');
      const tierComparePriceElement = tier.querySelector('[id^="pumper_originalAmount_"]');
      const tierQuantity = Number.parseInt(radio.value, 10) || 1;
      const tierSavingText = tier.querySelector('[data-tier-offer-subtitle]');
      const exactBundleTotals = { 2: 69.95, 3: 89.95 };
      const exactBundleTotal = isSoleReliefProductPage() ? exactBundleTotals[tierQuantity] : null;

      if (exactBundleTotal && tierPriceElement && tierComparePriceElement) {
        if (!tierComparePriceElement.dataset.srUnitPrice) {
          tierComparePriceElement.dataset.srUnitPrice = String(parseDisplayedMoney(tierComparePriceElement.textContent));
        }
        const exactCompareTotal = Number(tierComparePriceElement.dataset.srUnitPrice) * tierQuantity;
        const exactPriceText = formatMoney(exactBundleTotal).replace(/\s[A-Z]{3}$/, '');
        const exactCompareText = formatMoney(exactCompareTotal).replace(/\s[A-Z]{3}$/, '');
        const eachText = tier.querySelector('.pumper_each_price_text');

        if (tierPriceElement.textContent.trim() !== exactPriceText) tierPriceElement.textContent = exactPriceText;
        if (tierComparePriceElement.textContent.trim() !== exactCompareText) tierComparePriceElement.textContent = exactCompareText;
        if (eachText && eachText.textContent.trim().toLowerCase() !== 'total') eachText.textContent = ' total';
      }

      const tierPrice = parseDisplayedMoney(tierPriceElement?.textContent);
      const tierComparePrice = parseDisplayedMoney(tierComparePriceElement?.textContent);

      if (tierSavingText && tierPrice !== null && tierComparePrice !== null && tierComparePrice > tierPrice) {
        const exactTierSaving = formatMoney(
          exactBundleTotal ? tierComparePrice - tierPrice : (tierComparePrice - tierPrice) * tierQuantity
        ).replace(/\s[A-Z]{3}$/, '');
        const nextTierSavingText = `You Save ${exactTierSaving}`;
        if (tierSavingText.textContent.trim() !== nextTierSavingText) {
          tierSavingText.textContent = nextTierSavingText;
        }
      }
    });

    const selected = document.querySelector(`${PUMPER_RADIO_SELECTOR}:checked`);
    if (!selected) return;

    const offer = selected.closest('.pumper_template_9_block_wrapper') || selected.parentElement;
    if (!offer) return;

    const unitPriceElement = offer.querySelector('[id^="pumper_totalAmount_"]');
    const comparePriceElement = offer.querySelector('[id^="pumper_originalAmount_"]');
    const buttonText = document.querySelector('.shop-add-to-cart-button .button-text');
    if (!unitPriceElement || !buttonText) return;

    const unitPrice = parseDisplayedMoney(unitPriceElement.textContent);
    const comparePrice = parseDisplayedMoney(comparePriceElement?.textContent);
    const quantity = Number.parseInt(selected.value, 10) || 1;
    const isPerItem = offer.querySelector('.pumper_each_price_text')?.textContent.trim().toLowerCase() !== 'total';
    const multiplier = isPerItem ? quantity : 1;
    if (unitPrice === null) return;

    const label = (buttonText.textContent.split(' - ')[0] || 'Add to cart').trim();
    const totalPrice = formatMoney(unitPrice * multiplier);
    const totalComparePrice = comparePrice === null ? '' : formatMoney(comparePrice * multiplier);
    const nextHtml = `${label} - ${totalPrice}${
      totalComparePrice ? ` <span class="compare-price">(${totalComparePrice})</span>` : ''
    }`;

    if (buttonText.innerHTML !== nextHtml) buttonText.innerHTML = nextHtml;

  }

  let updateTimer;
  function scheduleBundlePriceUpdate() {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateBundleButtonPrice, 50);
  }

  function isSoleReliefProductPage() {
    return window.location.pathname.toLowerCase().includes('/products/sole-relief');
  }

  function getVariantPickerData() {
    const json = document.querySelector('.simple-variant-picker__variants-json');
    if (!json) return [];

    try {
      return JSON.parse(json.textContent).filter(function (variant) {
        return variant.available;
      });
    } catch (error) {
      return [];
    }
  }

  function syncSelectedVariant() {
    const selectedColor = document.querySelector('.simple-variant-picker__radio:checked');
    const variants = getVariantPickerData();
    const variant = variants.find(function (item) {
      return item.option1 === selectedColor?.value;
    });
    if (!variant) return null;

    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variant.id;
      input.disabled = false;
    });
    return variant;
  }

  function getBundleQuantity() {
    const selected = document.querySelector(`${PUMPER_RADIO_SELECTOR}:checked`);
    return Math.max(1, Number.parseInt(selected?.value, 10) || 1);
  }

  function getPumperOfferId() {
    const details = document.getElementById('pmpr_offer_details');
    try {
      const data = JSON.parse(details?.dataset.prvw_data || '{}');
      return data.metafieldData?.offerId || 'msj52e0w9f7lqf';
    } catch (error) {
      return 'msj52e0w9f7lqf';
    }
  }

  function installColourPickerStyles() {
    if (document.getElementById('sole-relief-colour-picker-styles')) return;
    const style = document.createElement('style');
    style.id = 'sole-relief-colour-picker-styles';
    style.textContent = `
      .sr-colour-picker[hidden] { display: none !important; }
      .sr-colour-picker { position: fixed; inset: 0; z-index: 2147483000; display: flex; align-items: flex-end; justify-content: center; font-family: var(--font-body-family-override, var(--font-body-family)); }
      .sr-colour-picker__backdrop { position: absolute; inset: 0; background: rgba(35, 25, 28, .58); backdrop-filter: blur(3px); }
      .sr-colour-picker__dialog { position: relative; width: 100%; max-width: 720px; max-height: 92dvh; overflow: auto; background: linear-gradient(180deg, #fff8fa 0%, #fff2f5 100%); color: #3d3d3d; border: 1px solid rgba(255,255,255,.7); border-radius: 26px 26px 0 0; padding: 26px 18px calc(20px + env(safe-area-inset-bottom)); box-shadow: 0 -18px 60px rgba(45, 31, 35, .24); }
      .sr-colour-picker__close { position: absolute; top: 16px; right: 16px; width: 42px; height: 42px; border: 1px solid rgba(61, 61, 61, .13); border-radius: 50%; background: rgba(255,255,255,.72); color: inherit; font-size: 25px; line-height: 1; cursor: pointer; box-shadow: 0 4px 14px rgba(61,61,61,.08); }
      .sr-colour-picker__eyebrow { margin: 0 52px 7px 0; color: #cf737f; font-size: 10px; line-height: 1; font-weight: 700; letter-spacing: .16em; text-transform: uppercase; }
      .sr-colour-picker__title { margin: 0 52px 6px 0; font-size: 26px; line-height: 1.15; font-weight: 700; letter-spacing: -.025em; }
      .sr-colour-picker__intro { margin: 0 0 22px; font-size: 14px; line-height: 1.45; opacity: .72; }
      .sr-colour-picker__item { margin: 0 0 16px; padding: 15px; border: 1px solid rgba(225, 133, 145, .32); border-radius: 18px; background: rgba(255, 255, 255, .7); box-shadow: 0 7px 22px rgba(102, 65, 73, .045); }
      .sr-colour-picker__legend { padding: 0 7px; margin-left: -7px; margin-bottom: 10px; color: #4a4042; font-size: 14px; font-weight: 700; }
      .sr-colour-picker__choices { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 9px; }
      .sr-colour-picker__choice { min-width: 0; }
      .sr-colour-picker__radio { position: absolute; opacity: 0; pointer-events: none; }
      .sr-colour-picker__label { display: flex; min-height: 88px; padding: 10px 4px 9px; flex-direction: column; align-items: center; justify-content: center; gap: 8px; border: 1px solid rgba(61, 61, 61, .13); border-radius: 14px; background: rgba(255,255,255,.9); font-size: 11px; line-height: 1.1; text-align: center; cursor: pointer; transition: transform .16s ease, border-color .16s ease, box-shadow .16s ease, background .16s ease; }
      .sr-colour-picker__swatch { position: relative; display: block; width: 46px; height: 46px; border: 3px solid #fff; border-radius: 50%; background: var(--sr-colour); box-shadow: 0 0 0 1px rgba(61,61,61,.12), 0 5px 12px rgba(61,61,61,.13); }
      .sr-colour-picker__swatch::after { content: ''; position: absolute; inset: 4px 7px auto; height: 11px; border-radius: 50%; background: rgba(255,255,255,.25); filter: blur(1px); }
      .sr-colour-picker__radio:checked + .sr-colour-picker__label { border: 2px solid #df8d98; background: #fff; box-shadow: 0 0 0 3px rgba(223, 141, 152, .14), 0 8px 20px rgba(92, 57, 64, .09); transform: translateY(-1px); }
      .sr-colour-picker__radio:focus-visible + .sr-colour-picker__label { outline: 2px solid #3d3d3d; outline-offset: 2px; }
      .sr-colour-picker__add { width: 100%; min-height: 58px; border: 0; border-radius: 12px; background: linear-gradient(135deg, #e3949f, #dc8491); color: #fff; font: inherit; font-size: 14px; font-weight: 700; letter-spacing: .035em; text-transform: uppercase; cursor: pointer; box-shadow: 0 10px 22px rgba(200, 105, 119, .2); }
      .sr-colour-picker__add[aria-disabled="true"] { opacity: .65; cursor: wait; }
      .sr-colour-picker__error { margin: 10px 0 0; color: #a12638; font-size: 13px; text-align: center; }
      .sr-replace-confirm { position: fixed; inset: 0; z-index: 2147483100; display: flex; align-items: center; justify-content: center; padding: 20px; font-family: var(--font-body-family-override, var(--font-body-family)); }
      .sr-replace-confirm__backdrop { position: absolute; inset: 0; background: rgba(35, 25, 28, .58); }
      .sr-replace-confirm__dialog { position: relative; width: min(100%, 410px); padding: 24px 20px 20px; border: 1px solid rgba(236, 149, 159, .42); border-radius: 18px; background: #fff3f6; color: #3d3d3d; box-shadow: 0 18px 60px rgba(35, 25, 28, .28); text-align: left; }
      .sr-replace-confirm__title { margin: 0 0 8px; font-size: 21px; line-height: 1.25; font-weight: 700; }
      .sr-replace-confirm__text { margin: 0 0 20px; font-size: 14px; line-height: 1.5; opacity: .82; }
      .sr-replace-confirm__actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
      .sr-replace-confirm__button { min-height: 50px; padding: 10px 12px; border: 1px solid #df8d98; border-radius: 8px; font: inherit; font-size: 13px; font-weight: 700; cursor: pointer; }
      .sr-replace-confirm__button--keep { background: transparent; color: #3d3d3d; }
      .sr-replace-confirm__button--replace { background: #df8d98; color: #fff; }
      .cart-drawer .cart-item.sr-bundle-line { display: flex !important; visibility: visible !important; opacity: 1 !important; }
      body.sr-colour-picker-open { overflow: hidden; }
      @media (min-width: 600px) { .sr-colour-picker { align-items: center; padding: 28px; } .sr-colour-picker__dialog { border-radius: 26px; padding: 32px; } .sr-colour-picker__title { font-size: 30px; } .sr-colour-picker__label { min-height: 104px; font-size: 12px; } .sr-colour-picker__swatch { width: 54px; height: 54px; } .sr-colour-picker__item { padding: 18px; } }
    `;
    document.head.appendChild(style);
  }

  function closeColourPicker() {
    const picker = document.querySelector('.sr-colour-picker');
    if (!picker) return;
    picker.hidden = true;
    document.body.classList.remove('sr-colour-picker-open');
  }

  function confirmBundleReplacement() {
    return new Promise(function (resolve) {
      installColourPickerStyles();
      document.querySelector('.sr-replace-confirm')?.remove();
      const modal = document.createElement('div');
      modal.className = 'sr-replace-confirm';
      modal.innerHTML = `
        <div class="sr-replace-confirm__backdrop" data-sr-keep-bundle></div>
        <section class="sr-replace-confirm__dialog" role="alertdialog" aria-modal="true" aria-labelledby="sr-replace-title" aria-describedby="sr-replace-text">
          <h2 class="sr-replace-confirm__title" id="sr-replace-title">Replace your current bundle?</h2>
          <p class="sr-replace-confirm__text" id="sr-replace-text">You already have a Sole Relief bundle in your cart. Only one bundle selection can be purchased per order. You can keep your current bundle or replace it with these new colours.</p>
          <div class="sr-replace-confirm__actions">
            <button type="button" class="sr-replace-confirm__button sr-replace-confirm__button--keep" data-sr-keep-bundle>Keep current</button>
            <button type="button" class="sr-replace-confirm__button sr-replace-confirm__button--replace" data-sr-replace-bundle>Replace bundle</button>
          </div>
        </section>`;

      function finish(value) {
        modal.remove();
        resolve(value);
      }

      modal.querySelectorAll('[data-sr-keep-bundle]').forEach(function (button) {
        button.addEventListener('click', function () { finish(false); });
      });
      modal.querySelector('[data-sr-replace-bundle]').addEventListener('click', function () { finish(true); });
      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') finish(false);
      });
      document.body.appendChild(modal);
      modal.querySelector('[data-sr-keep-bundle]').focus();
    });
  }

  function renderColourPicker(quantity, variants) {
    installColourPickerStyles();
    document.querySelector('.sr-colour-picker')?.remove();

    const currentVariant = syncSelectedVariant() || variants[0];
    const colourSwatches = {
      grey: '#929aa1',
      green: '#45b98d',
      pink: '#efa9b7',
      purple: '#8d59c7',
    };
    const picker = document.createElement('div');
    picker.className = 'sr-colour-picker';
    picker.innerHTML = `
      <div class="sr-colour-picker__backdrop" data-sr-close></div>
      <section class="sr-colour-picker__dialog" role="dialog" aria-modal="true" aria-labelledby="sr-colour-picker-title">
        <button type="button" class="sr-colour-picker__close" data-sr-close aria-label="Close colour selection">&times;</button>
        <p class="sr-colour-picker__eyebrow">Personalise your bundle</p>
        <h2 class="sr-colour-picker__title" id="sr-colour-picker-title">Choose your colours</h2>
        <p class="sr-colour-picker__intro">Pick a colour for each of your ${quantity} rollers.</p>
        <form class="sr-colour-picker__form">
          ${Array.from({ length: quantity }, function (_, itemIndex) {
            return `<fieldset class="sr-colour-picker__item">
              <legend class="sr-colour-picker__legend">Roller ${itemIndex + 1}</legend>
              <div class="sr-colour-picker__choices">
                ${variants.map(function (variant) {
                  const colourName = String(variant.option1 || variant.title || '').trim();
                  const swatchColour = colourSwatches[colourName.toLowerCase()] || '#d9d9d9';
                  const checked = variant.id === currentVariant.id ? ' checked' : '';
                  return `<div class="sr-colour-picker__choice">
                    <input class="sr-colour-picker__radio" type="radio" name="roller-${itemIndex}" id="sr-roller-${itemIndex}-${variant.id}" value="${variant.id}"${checked} required>
                    <label class="sr-colour-picker__label" for="sr-roller-${itemIndex}-${variant.id}" data-sr-variant-id="${variant.id}">
                      <span class="sr-colour-picker__swatch" style="--sr-colour: ${swatchColour}" aria-hidden="true"></span>
                      <span>${colourName}</span>
                    </label>
                  </div>`;
                }).join('')}
              </div>
            </fieldset>`;
          }).join('')}
          <button class="sr-colour-picker__add" type="submit">Add ${quantity} to cart</button>
          <p class="sr-colour-picker__error" role="alert" hidden></p>
        </form>
      </section>`;

    document.body.appendChild(picker);
    document.body.classList.add('sr-colour-picker-open');
    picker.querySelectorAll('[data-sr-close]').forEach(function (button) {
      button.addEventListener('click', closeColourPicker);
    });
    picker.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeColourPicker();
    });
    picker.querySelector('.sr-colour-picker__close').focus();
    picker.querySelectorAll('.sr-colour-picker__radio').forEach(function (radio) {
      if (radio.checked) radio.closest('.sr-colour-picker__item').dataset.srSelectedVariantId = radio.value;
      radio.addEventListener('change', function () {
        if (radio.checked) radio.closest('.sr-colour-picker__item').dataset.srSelectedVariantId = radio.value;
      });
    });
    picker.querySelectorAll('.sr-colour-picker__label').forEach(function (label) {
      label.addEventListener('click', function () {
        const input = document.getElementById(label.htmlFor);
        if (!input) return;
        input.checked = true;
        input.closest('.sr-colour-picker__item').dataset.srSelectedVariantId = label.dataset.srVariantId;
      });
    });
    picker.querySelector('.sr-colour-picker__form').addEventListener('submit', submitColourSelection);
  }

  function requestJson(method, url, body) {
    return new Promise(function (resolve, reject) {
      const request = new XMLHttpRequest();
      request.open(method, url, true);
      request.setRequestHeader('Accept', 'application/json');
      if (body) request.setRequestHeader('Content-Type', 'application/json');
      request.onload = function () {
        let data;
        try {
          data = JSON.parse(request.responseText);
        } catch (error) {
          if (method !== 'GET' && request.status >= 200 && request.status < 300) {
            resolve({ ok: true, status: request.status, data: {} });
            return;
          }
          reject(new Error('Shopify returned an invalid cart response.'));
          return;
        }
        resolve({ ok: request.status >= 200 && request.status < 300, status: request.status, data });
      };
      request.onerror = function () {
        reject(new Error('The cart request could not be completed. Please try again.'));
      };
      request.send(body ? JSON.stringify(body) : null);
    });
  }

  async function requestUnproxiedCartAdd(payload) {
    let bridge = document.getElementById('sr-cart-fetch-bridge');
    if (!bridge) {
      bridge = document.createElement('iframe');
      bridge.id = 'sr-cart-fetch-bridge';
      bridge.hidden = true;
      bridge.setAttribute('aria-hidden', 'true');
      document.head.appendChild(bridge);
    }

    const bridgeFetch = bridge.contentWindow?.fetch?.bind(bridge.contentWindow);
    if (!bridgeFetch) throw new Error('Unable to start the cart request. Please try again.');

    const response = await bridgeFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    let data = {};
    try {
      data = await response.json();
    } catch (error) {
      if (!response.ok) throw new Error('Shopify returned an invalid cart response.');
    }
    return { ok: response.ok, status: response.status, data };
  }

  async function addVariantsToCart(variantIds, submitButton, errorElement) {
    const quantities = variantIds.reduce(function (items, id) {
      items[id] = (items[id] || 0) + 1;
      return items;
    }, {});
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const pumperTier = `${getPumperOfferId()}.${Math.max(0, variantIds.length - 1)}`;
    const bundleInstance = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    const payload = {
      items: Object.entries(quantities).map(function ([id, quantity]) {
        return {
          id: Number(id),
          quantity,
          properties: {
            __pumper_bundles: pumperTier,
            _sr_bundle_instance: bundleInstance,
          },
        };
      }),
    };

    const buttonLabel = submitButton.querySelector('.button-text') || submitButton;
    const originalButtonText = buttonLabel.textContent;
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.disabled = true;
    buttonLabel.textContent = 'Adding…';
    if (errorElement) errorElement.hidden = true;

    try {
      const cartResponse = await requestJson('GET', window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js');
      if (!cartResponse.ok) throw new Error('Unable to check the current cart.');

      const offerId = getPumperOfferId();
      const updates = {};
      (cartResponse.data.items || []).forEach(function (item) {
        const properties = item.properties || {};
        const legacyOffer = String(properties.__pumper_bundles || '').split('.')[0];
        const currentOffer = String(properties._pumper_v2_offer_id || '');
        if (legacyOffer === offerId || currentOffer === offerId) updates[item.key] = 0;
      });

      if (Object.keys(updates).length) {
        const shouldReplace = await confirmBundleReplacement();
        if (!shouldReplace) {
          const cancelledError = new Error('Your existing bundle was kept.');
          cancelledError.isCancelled = true;
          throw cancelledError;
        }

        const removeResponse = await requestJson(
          'POST',
          '/cart/update.js',
          { updates }
        );
        if (!removeResponse.ok || removeResponse.data.status) {
          throw new Error(removeResponse.data.description || 'Unable to replace the existing bundle.');
        }
      }

      const addResponse = await requestUnproxiedCartAdd(payload);
      const result = addResponse.data;
      if (!addResponse.ok || result.status) throw new Error(result.description || 'Unable to add these colours.');

      closeColourPicker();
      window.location.assign('/cart');
    } catch (error) {
      if (error.isCancelled) {
        // The confirmation already explains the outcome; leave the picker open.
      } else if (errorElement) {
        errorElement.textContent = error.message || 'Something went wrong. Please try again.';
        errorElement.hidden = false;
      } else {
        window.alert(error.message || 'Something went wrong. Please try again.');
      }
      submitButton.removeAttribute('aria-disabled');
      submitButton.disabled = false;
      buttonLabel.textContent = originalButtonText;
    }
  }

  function submitColourSelection(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const variantIds = Array.from(form.querySelectorAll('.sr-colour-picker__item')).map(function (item) {
      return item.dataset.srSelectedVariantId || item.querySelector('.sr-colour-picker__radio:checked')?.value;
    }).filter(Boolean);
    const submitButton = form.querySelector('.sr-colour-picker__add');
    const errorElement = form.querySelector('.sr-colour-picker__error');
    addVariantsToCart(variantIds, submitButton, errorElement);
  }

  function interceptProductAdd(event) {
    if (!isSoleReliefProductPage()) return;
    const form = event.target.closest?.('form[action*="/cart/add"]');
    if (!form || !form.closest('product-form')) return;

    const variants = getVariantPickerData();
    if (!variants.length) return;

    const quantity = getBundleQuantity();
    if (quantity === 1) {
      const variant = syncSelectedVariant();
      if (!variant) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) addVariantsToCart([String(variant.id)], submitButton, null);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    renderColourPicker(quantity, variants);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches(PUMPER_RADIO_SELECTOR)) scheduleBundlePriceUpdate();
    if (event.target.matches('.simple-variant-picker__radio')) syncSelectedVariant();
  });

  document.addEventListener('submit', interceptProductAdd, true);

  document.addEventListener('click', function (event) {
    const productSubmitButton = event.target.closest('[type="submit"]');
    const productSubmitForm = productSubmitButton?.closest('form[action*="/cart/add"]');
    if (productSubmitForm?.closest('product-form') && isSoleReliefProductPage()) {
      interceptProductAdd(event);
      return;
    }

    const homeBuyButton = event.target.closest('.shop-add-to-cart-button[data-product-url]');
    if (
      homeBuyButton &&
      window.location.pathname === '/' &&
      homeBuyButton.dataset.persistentText?.trim().toLowerCase() === 'buy now'
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(homeBuyButton.dataset.productUrl);
      return;
    }

    if (event.target.closest('[class*="pumper__quantity_label"]')) scheduleBundlePriceUpdate();
  }, true);

  const observer = new MutationObserver(scheduleBundlePriceUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBundlePriceUpdate);
  } else {
    scheduleBundlePriceUpdate();
  }
})();
